<template>
    <Layout>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                        <div class="">
                            <div v-if="batches.length > 0" class="row mb-2">
                                <div class="col-sm-12">
                                    <span class="badge badge-success">Total Search Data Found: {{ batches.length }}</span>
                                    <download-excel
                                            class = "btn btn-light float-right"
                                            :data = "batches"
                                            :fields = "upcoming_batch_fields"
                                            :meta ="json_meta"
                                            worksheet = "Completed Batch"
                                            name = "completed-batch.xls">
                                        Download Excel
                                    </download-excel>
                                </div>
                            </div>
                            <div class="scrollable-table table-responsive" style="overflow-x: auto">
                                <table class="table table-centered table-striped">
                                    <thead>
                                    <tr>
                                        <th>Sl</th>
                                        <th>Training Trade</th>
                                        <th>Batch No</th>
                                        <th>Total Trainee</th>
                                        <th>Male</th>
                                        <th>Female</th>
                                        <th>Duration</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(batch, index) in batches" :key="index">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ batch.trade.desc }}</td>
                                        <td>{{ batch.batch_no }}</td>
                                        <td>{{ batch.trainees ? batch.trainees.length : 0 }}</td>
                                        <td>{{ batch.trainees ? countMale(batch.trainees) : 0 }}</td>
                                        <td>{{ batch.trainees ? countFemale(batch.trainees) : 0 }}</td>
                                        <td>{{ batch.duration.desc }}</td>
                                        <td>{{ customDate(batch.start_date) }}</td>
                                        <td>{{ customDate(batch.end_date) }}</td>
                                        <td>
                                            <router-link v-if="current_date < batch.end_date"
                                                         target="_blank" :to="{ name: 'batchEdit', params: { batch_id: batch.id } }"
                                                         tag="a" class="action-icon" title="Update batch">
                                                <i class="mdi mdi-square-edit-outline editButton"></i>
                                            </router-link>

                                            <a href="javascript:void(0);" v-if="current_date < batch.start_date"
                                               class="action-icon" title="Delete batch" @click="onDelete(batch.id, index)">
                                                <i class="mdi mdi-delete deleteButton"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <h5 v-if="batches.length === 0" class="text-center text-secondary">
                                    No Data Found
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import http from "@state/http";
    import moment from "moment";

    export default {
        page: {
            title: 'Batch',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader },
        data() {
            return {
                title: 'Completed Batch',
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Completed Batch',
                        href: '/batch/upcoming/list',
                    },
                    {
                        text: 'List',
                        active: true,
                    },
                ],
                batches: [],
                current_date: "",
                upcoming_batch_fields: {
                    'Training Trade': 'trade.desc',
                    'Batch No': 'batch_no',
                    'Duration': 'duration.desc',
                    'Start Date': 'start_date',
                    'End Date': 'end_date',
                    'Trainee Conveyances': 'trainee_conveyances',
                    'Tax %': 'vat_tax',
                    'Total Trainees' : {
                        callback: (value) => {
                            return `${value.trainees ? value.trainees.length : 0}`;
                        }
                    },
                    'Male' : {
                        callback: (value) => {
                            return `${value.traineeMaleCount ? value.traineeMaleCount : 0}`;
                        }
                    },
                    'Female' : {
                        callback: (value) => {
                            return `${value.traineeFemaleCount ? value.traineeFemaleCount : 0}`;
                        }
                    },
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            }
        },
        mounted() {
            this.checkCurrentDate();
            this.getCompletedBatches();
        },
        methods: {
            onDelete(id, index) {
                if (confirm("Do you really want to delete?")) {
                    http.delete("api/batches/" + id).then(response => {
                        this.batches.splice(index, 1);
                        this.$bvToast.toast(response.data.message, {
                            title: "Success",
                            autoHideDelay: 5000,
                            variant: "success"
                        });
                    });
                }
            },
            getCompletedBatches() {
                http.get("api/batch/completed/list").then(response => {
                    if (!response.error) {
                        this.batches = response.data.batches;
                    }
                });
            },
            countMale(trainees) {
                let count = 0;
                trainees.filter(p => {
                    if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 1) {
                        count += 1;
                    } else if (p.c_rep_gender_id === null && p.c_gender_id == 1) {
                        count += 1;
                    }
                });
                return count;
            },
            countFemale(trainees) {
                let count = 0;
                trainees.filter(p => {
                    if (p.c_rep_gender_id !== null && p.c_rep_gender_id == 2) {
                        count += 1;
                    } else if (p.c_rep_gender_id === null && p.c_gender_id == 2) {
                        count += 1;
                    }
                });
                return count;
            },
            checkCurrentDate() {
                this.current_date = moment().format("YYYY-MM-DD");
            },
            customDate(date) {
                return moment(date).format("LL");
            },
        },

    }
</script>